/* Runners 5K Lens Guide — data comes from the section's JSON script tag */
(function () {
  // build marker: check with `__lensGuideBuild` in the console
  window.__lensGuideBuild = 'v3-clean-cta-big-thumbs';
  var dataEl = document.getElementById('LensGuideData');
  var stageEl = document.getElementById('LensGuideStage');
  if (!dataEl || !stageEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var MODELS = (DATA.models || []).filter(function (m) { return m.colors && m.colors.length; });
  var SCENES = DATA.scenes || [];
  if (!MODELS.length || !SCENES.length) return;

  // per-tint stage treatment — demo values plus hueCast/hue: a moderate
  // color layer (mix-blend-mode: color) so each lens visibly shows its color.
  var LOOKS = {
    smoke : {scene:'trail',  cast:'linear-gradient(175deg, rgba(40,48,60,.34), rgba(24,29,38,.20))',
             filter:'saturate(1.12) contrast(1.08) brightness(1.00)', hue:'0'},
    rose  : {scene:'coast', cast:'linear-gradient(175deg, rgba(236,112,152,.38), rgba(190,72,122,.22))',
             filter:'saturate(1.16) contrast(1.05) brightness(1.03)',
             hueCast:'linear-gradient(175deg, rgb(236,112,152), rgb(190,72,122))', hue:'0.22'},
    ice   : {scene:'coast', cast:'linear-gradient(175deg, rgba(92,170,235,.36), rgba(52,118,198,.20))',
             filter:'saturate(1.14) contrast(1.06) brightness(1.03)',
             hueCast:'linear-gradient(175deg, rgb(92,170,235), rgb(52,118,198))', hue:'0.22'},
    silver: {scene:'coast', cast:'linear-gradient(175deg, rgba(212,226,240,.34), rgba(162,180,198,.18))',
             filter:'saturate(1.06) contrast(1.08) brightness(1.06)',
             hueCast:'linear-gradient(175deg, rgb(212,226,240), rgb(162,180,198))', hue:'0.10'},
    amber : {scene:'trail', cast:'linear-gradient(175deg, rgba(236,172,82,.40), rgba(190,126,52,.24))',
             filter:'saturate(1.16) contrast(1.05) brightness(1.03)',
             hueCast:'linear-gradient(175deg, rgb(236,172,82), rgb(190,126,52))', hue:'0.15'},
    cobalt: {scene:'road',  cast:'linear-gradient(175deg, rgba(72,122,220,.38), rgba(46,86,180,.22))',
             filter:'saturate(1.14) contrast(1.07) brightness(1.01)',
             hueCast:'linear-gradient(175deg, rgb(72,122,220), rgb(46,86,180))', hue:'0.20'}
  };

  // per-scene compensation: the backlit trail photo crushes to black without a
  // gamma shadow-lift; useHue adds the subtle per-lens color layer there.
  // Road/coast stay exactly as lens-comparison-demo.html.
  // new trail photo is bright; no per-scene shadow-lift needed
  var SCENE_LOOK = {};

  // best-looking scene per frame: X365 -> trail, Olympians -> desert, Sprinters -> city
  var MODEL_SCENE = ['trail', 'road', 'coast'];
  var modelSwitched = false;

  var $ = function (id) { return document.getElementById(id); };
  var root = document.documentElement;
  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var abs = function (u) { return new URL(u, location.href).href; };

  var mi = 0, ci = 0, si = 0, pos = 92;
  var shownScene = 0; // scene currently visible in the stage images
  var interacted = false, sceneLocked = false;

  /* links pass #model=<type>&product=<handle> in the hash (one cacheable URL
     for all products); the overlay passes its source URL via __lensGuideSrc.
     Match the exact colorway by product handle first, then the model tab.
     Query params still work for old cached links. */
  try {
    var src = window.__lensGuideSrc ? new URL(window.__lensGuideSrc, location.href) : location;
    var params = new URLSearchParams(src.search);
    var hashParams = new URLSearchParams(String(src.hash || '').replace(/^#/, ''));
    var wantedProduct = hashParams.get('product') || params.get('product');
    var matched = false;
    if (wantedProduct) {
      MODELS.some(function (m, mIdx) {
        var cIdx = m.colors.findIndex(function (c) { return c.handle === wantedProduct; });
        if (cIdx > -1) { mi = mIdx; ci = cIdx; matched = true; }
        return matched;
      });
    }
    var wantedModel = hashParams.get('model') || params.get('model');
    if (!matched && wantedModel) {
      var handleize = function (s) {
        return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      };
      var found = MODELS.findIndex(function (m) { return handleize(m.name) === wantedModel; });
      if (found > -1) mi = found;
    }
  } catch (e) {}

  /* build tabs + scene buttons */
  MODELS.forEach(function (m, i) {
    var b = document.createElement('button');
    b.className = 'tab'; b.setAttribute('role', 'tab'); b.id = 'tab-' + i;
    b.setAttribute('aria-label', m.name + ' sunglasses');
    if (m.colors[0] && m.colors[0].chip) {
      var thumbWrap = document.createElement('span');
      thumbWrap.className = 'tab-thumb';
      var tim = document.createElement('img');
      tim.src = m.colors[0].chip; tim.alt = '';
      thumbWrap.appendChild(tim);
      b.appendChild(thumbWrap);
    }
    var tsp = document.createElement('span');
    tsp.textContent = m.name;
    b.appendChild(tsp);
    b.addEventListener('click', function () { selectModel(i); });
    $('LensGuideTabs').appendChild(b);
  });
  $('LensGuideTabs').style.gridTemplateColumns = 'repeat(' + MODELS.length + ',1fr)';

  SCENES.forEach(function (s, i) {
    var b = document.createElement('button');
    b.className = 'scene-btn'; b.dataset.label = s.label;
    b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
    b.setAttribute('aria-label', 'Scene: ' + s.label.toLowerCase());
    var im = document.createElement('img');
    im.src = s.thumb; im.alt = ''; im.width = 64; im.height = 42;
    b.appendChild(im);
    b.addEventListener('click', function (e) { e.stopPropagation(); sceneLocked = true; selectScene(i); });
    b.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    $('LensGuideScenes').appendChild(b);
  });

  function model () { return MODELS[mi]; }
  function color () { return model().colors[ci]; }

  function applyLook () {
    var look = LOOKS[color().tint] || LOOKS.smoke;
    // key scene compensation to the image on screen, not the pending scene,
    // so road/coast never flash the trail treatment during the crossfade
    var extra = SCENE_LOOK[SCENES[shownScene].id] || {};
    $('LensGuideTint').style.background = look.cast;
    $('LensGuideTint').style.opacity = extra.tintOpacity || '';
    var hueEl = $('LensGuideTintHue');
    if (hueEl) {
      hueEl.style.background = look.hueCast || 'none';
      hueEl.style.opacity = extra.useHue ? (look.hue || '0') : '0';
    }
    $('LensGuideLensImg').style.filter = 'url(#' + (extra.clarity || 'k5-clarity') + ') '
      + look.filter + (extra.filter ? ' ' + extra.filter : '');
  }

  function renderModel () {
    var m = model();
    Array.prototype.forEach.call($('LensGuideTabs').children, function (t, i) {
      t.setAttribute('aria-selected', i === mi ? 'true' : 'false');
    });
    var nameEl = $('LensGuideModelName');
    nameEl.textContent = m.name;
    if (m.sup) {
      var sup = document.createElement('sup');
      sup.textContent = m.sup;
      nameEl.appendChild(sup);
    }
    $('LensGuideModelTag').textContent = m.tag;
    $('LensGuideSpecs').innerHTML = m.specs.map(function (s) {
      return '<div class="spec"><span class="k"></span><span class="v"></span></div>';
    }).join('');
    Array.prototype.forEach.call($('LensGuideSpecs').children, function (el, i) {
      el.children[0].textContent = m.specs[i][0];
      el.children[1].textContent = m.specs[i][1];
    });

    var chips = $('LensGuideChips');
    chips.innerHTML = '';
    m.colors.forEach(function (c, i) {
      var b = document.createElement('button');
      b.className = 'chip'; b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', c.name + ', ' + c.lens + ' lens');
      var im = document.createElement('img');
      im.src = c.chip; im.alt = ''; im.loading = 'lazy'; im.width = 62; im.height = 62;
      b.appendChild(im);
      b.addEventListener('click', function () { selectColor(i); });
      chips.appendChild(b);
    });
    renderColor();
  }

  function renderColor () {
    var c = color();
    root.style.setProperty('--lg-accent', c.accent);
    Array.prototype.forEach.call($('LensGuideChips').children, function (ch, i) {
      ch.setAttribute('aria-checked', i === ci ? 'true' : 'false');
    });
    $('LensGuideColorLabel').innerHTML = '<span></span> <em></em>';
    $('LensGuideColorLabel').children[0].textContent = c.name;
    $('LensGuideColorLabel').children[1].textContent = '· ' + c.lens + ' lens';
    $('LensGuideLensLabel').textContent = '5K ' + c.lens.toUpperCase();
    var look = LOOKS[c.tint] || LOOKS.smoke;
    if (!sceneLocked) {
      var targetScene = modelSwitched ? (MODEL_SCENE[mi] || look.scene) : look.scene;
      var best = SCENES.findIndex(function (sc) { return sc.id === targetScene; });
      if (best !== -1 && best !== si) selectScene(best);
    }
    modelSwitched = false;
    applyLook();
    var view = $('LensGuideCta');
    if (view) view.href = c.url;
    var atc = $('LensGuideAtc');
    if (atc) {
      atc.classList.remove('added');
      atc.dataset.state = 'idle';
      $('LensGuideAtcArrow').textContent = '→';
      atc.setAttribute('aria-label', (c.available === false ? 'Sold out: ' : 'Add to cart: ') + model().name + ' ' + c.name + (c.price ? ', ' + c.price : ''));
      if (c.available === false || !c.variant) {
        atc.disabled = true;
        $('LensGuideCtaText').textContent = 'Sold Out';
      } else {
        atc.disabled = false;
        $('LensGuideCtaText').textContent = 'Add to Cart';
      }
      var priceEl = $('LensGuidePrice');
      if (priceEl) priceEl.textContent = c.price || '';
    }

    var im = $('LensGuideProductImg');
    var next = abs(c.img);
    if (im.src !== next) {
      im.classList.add('swap');
      var pre = new Image();
      pre.src = next;
      var go = function () {
        im.src = next;
        im.alt = model().name + ' in ' + c.name + ' with ' + c.lens + ' lens';
        requestAnimationFrame(function () { im.classList.remove('swap'); });
      };
      (pre.decode ? pre.decode().catch(function () {}) : Promise.resolve()).then(go);
    }
  }

  function selectModel (i) { if (i === mi) return; mi = i; ci = 0; modelSwitched = true; renderModel(); }
  function selectColor (i) { ci = i; renderColor(); }

  function selectScene (i) {
    if (i === si) return; si = i;
    Array.prototype.forEach.call($('LensGuideScenes').children, function (b, bi) {
      b.setAttribute('aria-pressed', bi === i ? 'true' : 'false');
    });
    var src = SCENES[i].src;
    var pre = new Image(); pre.src = src;
    (pre.decode ? pre.decode().catch(function () {}) : Promise.resolve()).then(function () {
      stageEl.classList.add('switching');
      setTimeout(function () {
        $('LensGuideNakedImg').src = src;
        $('LensGuideLensImg').src = src;
        shownScene = i;
        applyLook();
        requestAnimationFrame(function () { stageEl.classList.remove('switching'); });
      }, 240);
    });
  }

  /* divider */
  function setPos (p) {
    pos = Math.min(100, Math.max(0, p));
    root.style.setProperty('--lg-pos', pos);
    var d = $('LensGuideDivider');
    d.setAttribute('aria-valuenow', Math.round(100 - pos));
    d.setAttribute('aria-valuetext', '5K lens covering ' + Math.round(100 - pos) + '% of the view');
  }

  var dragging = false;
  function pointerPos (e) {
    var r = stageEl.getBoundingClientRect();
    return ((e.clientX - r.left) / r.width) * 100;
  }
  stageEl.addEventListener('dragstart', function (e) { e.preventDefault(); });
  stageEl.addEventListener('pointerdown', function (e) {
    dragging = true; interacted = true;
    stageEl.setPointerCapture(e.pointerId);
    hideHint(); setPos(pointerPos(e));
  });
  stageEl.addEventListener('pointermove', function (e) { if (dragging) setPos(pointerPos(e)); });
  stageEl.addEventListener('pointerup', function () { dragging = false; });
  stageEl.addEventListener('pointercancel', function () { dragging = false; });
  stageEl.addEventListener('dblclick', function () { animateTo(50); });

  $('LensGuideDivider').addEventListener('keydown', function (e) {
    var step = e.shiftKey ? 10 : 2;
    if (e.key === 'ArrowLeft') { setPos(pos - step); e.preventDefault(); interacted = true; hideHint(); }
    if (e.key === 'ArrowRight') { setPos(pos + step); e.preventDefault(); interacted = true; hideHint(); }
  });

  function animateTo (target, dur) {
    dur = dur || 900;
    if (reduceMotion) { setPos(target); return; }
    var from = pos, t0 = performance.now();
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    (function tick (now) {
      var t = Math.min(1, (now - t0) / dur);
      setPos(from + (target - from) * ease(t));
      if (t < 1 && !dragging) requestAnimationFrame(tick);
    })(t0);
  }

  function hideHint () { $('LensGuideDragHint').classList.add('hide'); }

  var closeBtn = $('LensGuideClose');
  closeBtn.addEventListener('click', function () {
    // the inline overlay cancels this event and closes itself
    var unhandled = document.dispatchEvent(new CustomEvent('lens-guide:close', { cancelable: true }));
    if (!unhandled) return;
    if (window.parent !== window) {
      window.parent.postMessage({ type: 'lens-guide-close' }, location.origin);
      return;
    }
    var sameOrigin = false;
    try { sameOrigin = document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) {}
    if (sameOrigin && history.length > 1) history.back();
    else location.href = closeBtn.dataset.fallback || '/';
  });

  /* direct add to cart */
  var atcBtn = $('LensGuideAtc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var c = color();
      if (atcBtn.dataset.state === 'added') {
        (window.top || window).location.href = '/cart';
        return;
      }
      if (!c.variant || c.available === false || atcBtn.dataset.state === 'busy') return;
      atcBtn.dataset.state = 'busy';
      $('LensGuideCtaText').textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: c.variant, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        atcBtn.dataset.state = 'added';
        atcBtn.classList.add('added');
        $('LensGuideCtaText').textContent = 'Added ✓ View Cart';
      }).catch(function () {
        atcBtn.dataset.state = 'idle';
        $('LensGuideCtaText').textContent = 'Add to Cart';
        if (c.url) (window.top || window).location.href = c.url;
      });
    });
  }

  /* init */
  renderModel();
  setPos(92);

  var first = new Image(); first.src = SCENES[0].src;
  (first.decode ? first.decode().catch(function () {}) : Promise.resolve()).then(function () {
    setTimeout(function () { animateTo(50); }, reduceMotion ? 0 : 350);
  });

  setTimeout(function () {
    if (!interacted && !reduceMotion) $('LensGuideKnob').classList.add('hint');
  }, 4200);
  setTimeout(hideHint, 7000);

  /* preload remaining scenes + product images for instant switching */
  function preloadAll () {
    SCENES.slice(1).forEach(function (s) { new Image().src = s.src; });
    MODELS.forEach(function (m) {
      m.colors.forEach(function (c) {
        new Image().src = c.img;
        new Image().src = c.chip;
      });
    });
  }
  if (document.readyState === 'complete') setTimeout(preloadAll, 300);
  else addEventListener('load', preloadAll);
})();
